import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { REST_BIOMETRIE_URL } from '../app.config';
import { ValueListItem } from '../models/rest/valuelist/valuelist';
import { UserSettingsService } from './usersettings.service';


@Injectable()
export class LichtbildService implements OnDestroy {
  private subscription: Subscription = new Subscription();

  private static readonly SEARCH_STRING = '/';
  private static readonly REPLACEMENT = 'SLASH';
  lichtbildDevices: string[] = [];
  private lastUsedDevice?: string;

  constructor(private http: HttpClient, private userSettingsService: UserSettingsService) {
    this.subscription.add(this.userSettingsService.lichtbildDevice$.subscribe(lichtbildDevice => this.lastUsedDevice = lichtbildDevice));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getLichtbildDevices(): Observable<ValueListItem[]> {
    const ret: BehaviorSubject<ValueListItem[]> = new BehaviorSubject<ValueListItem[]>([]);

    for (const lichtbildDevice of this.lichtbildDevices) {
      ret.getValue().push({
        key: lichtbildDevice,
        value: lichtbildDevice
      });
    }

    return ret;
  }

  fetchLichtbildDevices(): Observable<any> {
    const ret: Observable<any> = this.http
    .get<string[]>(REST_BIOMETRIE_URL + '/face/device-names').pipe(
      tap((result) => {
        for (const singleResultKey of result) {
          this.lichtbildDevices.push(singleResultKey);
        }
      }));
    return ret;
  }

  captureLichtbild(deviceName: string): Observable<any> {
    deviceName = deviceName.replace(LichtbildService.SEARCH_STRING, LichtbildService.REPLACEMENT);
    const apiUrl = REST_BIOMETRIE_URL + '/face/devices/' + encodeURIComponent(deviceName) + '/capture';
    return this.http.post(apiUrl, {}, {
      observe: 'body',
      responseType: 'blob'
    });
  }

  findInitialDevice(): string {
    if (this.lastUsedDevice && this.hasDeviceInList()) {
      return this.lastUsedDevice;
    } else if (this.lichtbildDevices.length > 0) {
      return this.lichtbildDevices[0];
    } else {
      return undefined;
    }
  }

  public changeLastUsedDevice(device: string): void {
    this.userSettingsService.saveUserSettings({ lichtbildDevice: device });
  }

  private hasDeviceInList(): boolean {
    return this.lichtbildDevices.includes(this.lastUsedDevice);
  }

}
